import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgLipBalmGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M27.598 19.813v-8.016c0-.296 0-.593-.093-.99-.28-1.187-1.028-2.077-2.056-2.473-.655-.297-1.309-.396-1.963-.297-1.308.198-2.337 1.089-2.804 2.375-.093.495-.187.89-.187 1.385v8.016H19V40h10V19.813h-1.402Zm-5.794-8.906c.28-.89.934-1.485 1.775-1.583h.374c.374 0 .655.098 1.028.197a2.49 2.49 0 0 1 1.402 1.683c0 .099.094.297.094.593 0 .396-.094.891-.28 1.287a.752.752 0 0 0-.375.396c-.467.495-1.028.791-1.682.791-.654 0-1.308-.198-1.776-.692-.093-.198-.28-.396-.373-.594a2.759 2.759 0 0 1-.28-1.188c0-.296 0-.593.093-.89Zm-.094 3.661c.654.594 1.496.99 2.337.99h.093c.841 0 1.682-.396 2.337-.99v5.245H21.71v-5.245Zm6.075 24.146h-7.663V21h7.663v17.714Z",
    fill: "currentColor"
  }));
}

export { SvgLipBalmGlyph as default };
